export default __webpack_public_path__ + "static/media/search.55efc0f1.svg";